// extracted by mini-css-extract-plugin
export default {"root":"Subscription_root__jHtAw"};